import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { hooksActions } from '@src/store/reducers/hooksReducer';

export const createHooksMiddleware = (http: any, successPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [hooksActions.GET_HOOKS_MODELS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}projects/hook/models`);
            next({ type: hooksActions.SET_HOOKS_MODELS, payload: response.data });
            return response.data;
        },
        [hooksActions.GET_ACTION_MODELS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}projects/hook/${payload.model}/actions`);
            next({ type: hooksActions.SET_ACTION_MODELS, payload: response.data });
            return response.data;
        },
        [hooksActions.GET_HOOKS_EVENTS_AND_STEPS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}projects/${payload.projId}/hook/conditions`);
            next({ type: hooksActions.SET_HOOKS_EVENTS_AND_STEPS, payload: response.data });
            return response.data;
        },
        [hooksActions.GET_HOOK_PARAMETERS]: async ({ payload }: any, next: Next) => {
            const response = await  http.get(`${restServiceUrl}projects/hook/${payload.model}/action/${payload.actionName}/properties`);
            next({ type: hooksActions.SET_HOOK_PARAMETERS, payload: response.data });
            return response.data;
        },
        [hooksActions.SAVE_HOOK]: async ({ payload }: any) => {
            const response = await http.post(`${restServiceUrl}projects/hook/save/${payload.projId}`, payload.hookData);
            if (response.data) {
                successPopUp();
            }
            return response.data;
        },
        [hooksActions.DELETE_HOOK]: async ({ payload }: any) => {
            const response = await http.delete(`${restServiceUrl}projects/hook/${payload.hookId}`);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/hooks.middleware.ts